import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../hooks/usePostHook";
import CreateIcon from "../../icons/CreateIcon";
import { IPage } from "../../types/interface";

const CreatePageComponent = loadable(
  () => import("../../components/Pages/Create")
);

export default function CreatePage() {
  const { mutateAsync: createPage, isLoading: isCreatingPage } = usePostHook({
    queryKey: ["create-page"],
    navigateURL: "/website-builder/pages",
  });

  const handleCreate = async (
    data: IPage,
    setError: UseFormSetError<IPage>
  ) => {
    try {
      const url = APIS.PAGE;
      await createPage({
        url,
        formData: {
          ...data,
          popup_pages: data?.popup_pages?.map((pp) => pp.value),
          html_content: data?.page_contents?.html_content,
          css_content: data?.page_contents?.css_content,
          project_data: data?.page_contents?.project_data,
        },
        setError,
      });
    } catch (e) {
      if (e instanceof Error) toast.error(e.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Page
        </span>
      </div>
      <CreatePageComponent
        handleCreate={handleCreate}
        isCreatingPage={isCreatingPage}
      />
    </>
  );
}
